import { DeleteOutlined } from '@ant-design/icons';
import cs from 'classnames';
import Button, { type ButtonProperties } from './Button';

type P = ButtonProperties;

const DeleteButton = ({ item, ...rest }: P) => (
  <Button
    item={{
      icon: <DeleteOutlined className="delete-button__icon" />,
      ...item,
      className: cs('delete-button', item?.className),
    }}
    {...rest}
  />
);

export default DeleteButton;
